import {
  IconDefinition,
  IconName,
  IconPrefix,
} from "@fortawesome/fontawesome-svg-core";

/*
// Example template
// Use this to add new icons from custom SVGs

export const customMyNewIcon: IconDefinition = {
  prefix: "fad" as IconPrefix,
  iconName: "customMyNewIcon" as IconName,
  icon: [
    512, // SVG viewBox width
    512, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (background circle)
      "",
       // primary path (main icon conent)
      "",
    ],
  ],
};
*/

// Because fontawesome doesn't allow duotone import of kit icons [they say it's coming soon(tm)]
// Manually constructing IconDefinitions from custom svgs is the least painful option that works
export const customShieldLock: IconDefinition = {
  prefix: "fad" as IconPrefix,
  iconName: "customShieldLock" as IconName,
  icon: [
    20, // SVG viewBox width
    25, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // primary path (lock icon)
      "M9.73828 24.793C9.92578 24.793 10.2305 24.7227 10.5234 24.5586C17.1914 20.8203 19.4766 19.2383 19.4766 14.9609V5.99609C19.4766 4.76562 18.9492 4.37891 17.9531 3.95703C16.5703 3.38281 12.1055 1.77734 10.7227 1.29687C10.4062 1.19141 10.0664 1.12109 9.73828 1.12109C9.41016 1.12109 9.07031 1.21484 8.76562 1.29687C7.38281 1.69531 2.90625 3.39453 1.52344 3.95703C0.539062 4.36719 0 4.76562 0 5.99609V14.9609C0 19.2383 2.29688 20.8086 8.95312 24.5586C9.25781 24.7227 9.55078 24.793 9.73828 24.793ZM9.73828 22.6719C9.55078 22.6719 9.36328 22.6016 9.01172 22.3906C3.59766 19.1094 1.86328 18.1484 1.86328 14.5273V6.35938C1.86328 5.96094 1.93359 5.80859 2.26172 5.67969C4.04297 4.97656 7.5 3.81641 9.26953 3.11328C9.45703 3.03125 9.60938 3.00781 9.73828 3.00781C9.86719 3.00781 10.0195 3.04297 10.207 3.11328C11.9766 3.81641 15.4102 5.05859 17.2266 5.67969C17.543 5.79688 17.6133 5.96094 17.6133 6.35938V14.5273C17.6133 18.1484 15.8789 19.0977 10.4648 22.3906C10.125 22.6016 9.92578 22.6719 9.73828 22.6719ZM5.50781 17.0117C5.50781 17.8906 5.89453 18.3008 6.70312 18.3008H12.7734C13.582 18.3008 13.9688 17.8906 13.9688 17.0117V12.3477C13.9688 11.5273 13.6289 11.1172 12.9375 11.0703V9.6875C12.9375 7.53125 11.6484 6.08984 9.73828 6.08984C7.82812 6.08984 6.53906 7.53125 6.53906 9.6875V11.0703C5.84766 11.1172 5.50781 11.5273 5.50781 12.3477V17.0117ZM7.75781 11.0586V9.55859C7.75781 8.17578 8.55469 7.27344 9.73828 7.27344C10.9219 7.27344 11.7188 8.17578 11.7188 9.55859V11.0586H7.75781Z",
    ],
  ],
};

export const customShieldLockWithoutOuterCircle: IconDefinition = {
  prefix: "fad" as IconPrefix,
  iconName: "customShieldLockWithoutOuterCircle" as IconName,
  icon: [
    20, // SVG viewBox width
    25, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // primary path (lock icon)
      "M9.73828 24.793C9.92578 24.793 10.2305 24.7227 10.5234 24.5586C17.1914 20.8203 19.4766 19.2383 19.4766 14.9609V5.99609C19.4766 4.76562 18.9492 4.37891 17.9531 3.95703C16.5703 3.38281 12.1055 1.77734 10.7227 1.29687C10.4062 1.19141 10.0664 1.12109 9.73828 1.12109C9.41016 1.12109 9.07031 1.21484 8.76562 1.29687C7.38281 1.69531 2.90625 3.39453 1.52344 3.95703C0.539062 4.36719 0 4.76562 0 5.99609V14.9609C0 19.2383 2.29688 20.8086 8.95312 24.5586C9.25781 24.7227 9.55078 24.793 9.73828 24.793ZM9.73828 22.6719C9.55078 22.6719 9.36328 22.6016 9.01172 22.3906C3.59766 19.1094 1.86328 18.1484 1.86328 14.5273V6.35938C1.86328 5.96094 1.93359 5.80859 2.26172 5.67969C4.04297 4.97656 7.5 3.81641 9.26953 3.11328C9.45703 3.03125 9.60938 3.00781 9.73828 3.00781C9.86719 3.00781 10.0195 3.04297 10.207 3.11328C11.9766 3.81641 15.4102 5.05859 17.2266 5.67969C17.543 5.79688 17.6133 5.96094 17.6133 6.35938V14.5273C17.6133 18.1484 15.8789 19.0977 10.4648 22.3906C10.125 22.6016 9.92578 22.6719 9.73828 22.6719ZM5.50781 17.0117C5.50781 17.8906 5.89453 18.3008 6.70312 18.3008H12.7734C13.582 18.3008 13.9688 17.8906 13.9688 17.0117V12.3477C13.9688 11.5273 13.6289 11.1172 12.9375 11.0703V9.6875C12.9375 7.53125 11.6484 6.08984 9.73828 6.08984C7.82812 6.08984 6.53906 7.53125 6.53906 9.6875V11.0703C5.84766 11.1172 5.50781 11.5273 5.50781 12.3477V17.0117ZM7.75781 11.0586V9.55859C7.75781 8.17578 8.55469 7.27344 9.73828 7.27344C10.9219 7.27344 11.7188 8.17578 11.7188 9.55859V11.0586H7.75781Z",
    ],
  ],
};

export const customInvertedColorsShieldLock: IconDefinition = {
  prefix: "fad" as IconPrefix,
  iconName: "customInvertedColorsShieldLock" as IconName,
  icon: [
    53, // SVG viewBox width
    64, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData
    [
      // secondary path (empty)
      "",
      // primary path(inverted lock icon)
      "M27 65.5C27.5183 65.5 28.3282 65.3066 29.1382 64.8882C47.5713 55.2943 53.5 50.4974 53.5 38.9398V14.6654C53.5 11.3494 52.0744 10.287 49.3533 9.16023C45.563 7.61492 33.4469 3.23653 29.6889 1.94877C28.8142 1.65902 27.9071 1.49805 27 1.49805C26.0929 1.49805 25.1858 1.69121 24.3435 1.94877C20.5532 3.17214 8.43702 7.64711 4.64669 9.16023C1.95782 10.2548 0.5 11.3494 0.5 14.6654V38.9398C0.5 50.4974 6.75244 54.7471 24.8618 64.8882C25.7041 65.339 26.4816 65.5 27 65.5ZM14.9486 45.4431V32.2434C14.9486 29.8932 15.9205 28.7341 17.8643 28.6056V24.71C17.8643 18.5931 21.5574 14.4723 27 14.4723C32.4425 14.4723 36.1356 18.5931 36.1356 24.71V28.6056C38.0796 28.7341 39.0513 29.8932 39.0513 32.2434V45.4431C39.0513 47.9219 37.9499 49.0809 35.6496 49.0809H18.3502C16.0501 49.0809 14.9486 47.9219 14.9486 45.4431ZM21.3631 28.5734H32.6369V24.3237C32.6369 20.4282 30.3692 17.8527 27 17.8527C23.6308 17.8527 21.3631 20.4282 21.3631 24.3237V28.5734Z",
    ],
  ],
};

export const customDeliveryStatusCalendar: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customDeliveryStatusCalendar" as IconName,
  icon: [
    33, // SVG viewBox width
    33, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (calendar)
      "M10.3134 25.6778H23.2495C25.2287 25.6778 26.2136 24.7185 26.2136 22.8183V11.5558C26.2136 9.65559 25.2287 8.69629 23.2495 8.69629H10.3134C8.3342 8.69629 7.33984 9.64637 7.33984 11.5558V22.8183C7.33984 24.7277 8.3342 25.6778 10.3134 25.6778ZM10.1714 24.1927C9.32855 24.1927 8.86452 23.7592 8.86452 22.9014V14.2031C8.86452 13.3544 9.32855 12.9117 10.1714 12.9117H23.3726C24.2154 12.9117 24.689 13.3544 24.689 14.2031V22.9014C24.689 23.7592 24.2154 24.1927 23.3726 24.1927H10.1714ZM14.9348 16.2231H15.4935C15.825 16.2231 15.9292 16.1309 15.9292 15.808V15.2638C15.9292 14.941 15.825 14.8395 15.4935 14.8395H14.9348C14.6034 14.8395 14.4897 14.941 14.4897 15.2638V15.808C14.4897 16.1309 14.6034 16.2231 14.9348 16.2231ZM18.0789 16.2231H18.6376C18.969 16.2231 19.0826 16.1309 19.0826 15.808V15.2638C19.0826 14.941 18.969 14.8395 18.6376 14.8395H18.0789C17.7474 14.8395 17.6338 14.941 17.6338 15.2638V15.808C17.6338 16.1309 17.7474 16.2231 18.0789 16.2231ZM21.2229 16.2231H21.7816C22.113 16.2231 22.2267 16.1309 22.2267 15.808V15.2638C22.2267 14.941 22.113 14.8395 21.7816 14.8395H21.2229C20.8914 14.8395 20.7873 14.941 20.7873 15.2638V15.808C20.7873 16.1309 20.8914 16.2231 21.2229 16.2231ZM11.7908 19.2394H12.34C12.6809 19.2394 12.7851 19.1472 12.7851 18.8243V18.2801C12.7851 17.9573 12.6809 17.865 12.34 17.865H11.7908C11.4498 17.865 11.3457 17.9573 11.3457 18.2801V18.8243C11.3457 19.1472 11.4498 19.2394 11.7908 19.2394ZM14.9348 19.2394H15.4935C15.825 19.2394 15.9292 19.1472 15.9292 18.8243V18.2801C15.9292 17.9573 15.825 17.865 15.4935 17.865H14.9348C14.6034 17.865 14.4897 17.9573 14.4897 18.2801V18.8243C14.4897 19.1472 14.6034 19.2394 14.9348 19.2394ZM18.0789 19.2394H18.6376C18.969 19.2394 19.0826 19.1472 19.0826 18.8243V18.2801C19.0826 17.9573 18.969 17.865 18.6376 17.865H18.0789C17.7474 17.865 17.6338 17.9573 17.6338 18.2801V18.8243C17.6338 19.1472 17.7474 19.2394 18.0789 19.2394ZM21.2229 19.2394H21.7816C22.113 19.2394 22.2267 19.1472 22.2267 18.8243V18.2801C22.2267 17.9573 22.113 17.865 21.7816 17.865H21.2229C20.8914 17.865 20.7873 17.9573 20.7873 18.2801V18.8243C20.7873 19.1472 20.8914 19.2394 21.2229 19.2394ZM11.7908 22.2649H12.34C12.6809 22.2649 12.7851 22.1634 12.7851 21.8406V21.2963C12.7851 20.9735 12.6809 20.8813 12.34 20.8813H11.7908C11.4498 20.8813 11.3457 20.9735 11.3457 21.2963V21.8406C11.3457 22.1634 11.4498 22.2649 11.7908 22.2649ZM14.9348 22.2649H15.4935C15.825 22.2649 15.9292 22.1634 15.9292 21.8406V21.2963C15.9292 20.9735 15.825 20.8813 15.4935 20.8813H14.9348C14.6034 20.8813 14.4897 20.9735 14.4897 21.2963V21.8406C14.4897 22.1634 14.6034 22.2649 14.9348 22.2649ZM18.0789 22.2649H18.6376C18.969 22.2649 19.0826 22.1634 19.0826 21.8406V21.2963C19.0826 20.9735 18.969 20.8813 18.6376 20.8813H18.0789C17.7474 20.8813 17.6338 20.9735 17.6338 21.2963V21.8406C17.6338 22.1634 17.7474 22.2649 18.0789 22.2649Z",
    ],
  ],
};

export const customStackedFilesIcon: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customStackedFilesIcon" as IconName,
  icon: [
    20, // SVG viewBox width
    24, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (stacked files)
      "M0.736816 20.4424V8.4541C0.736816 6.51172 1.76514 5.4834 3.68994 5.4834H5.14893V3.85742C5.14893 1.91504 6.17725 0.87793 8.10205 0.87793H11.3628C12.4263 0.87793 13.2524 1.15918 13.938 1.85352L18.2798 6.2832C19.0005 7.02148 19.2554 7.79492 19.2554 9.00781V15.8457C19.2554 17.7881 18.2271 18.8164 16.3022 18.8164H14.8433V20.4424C14.8433 22.3848 13.8149 23.4219 11.8901 23.4219H3.68994C1.75635 23.4219 0.736816 22.3936 0.736816 20.4424ZM13.9204 11.1699C14.6851 11.9434 14.8433 12.541 14.8433 13.7627V16.8652H16.1001C16.9087 16.8652 17.2954 16.4434 17.2954 15.6787V8.57715H13.5952C12.4702 8.57715 11.8286 7.95312 11.8286 6.81055V2.83789H8.3042C7.49561 2.83789 7.10889 3.25977 7.10889 4.02441V5.49219C7.99658 5.52734 8.56787 5.74707 9.21826 6.39746L13.9204 11.1699ZM13.3931 6.59082C13.3931 6.88965 13.5249 7.0127 13.8149 7.0127H16.7856L13.3931 3.56738V6.59082ZM2.69678 20.2754C2.69678 21.0488 3.0835 21.4619 3.8833 21.4619H11.688C12.4966 21.4619 12.8833 21.0488 12.8833 20.2754V14.0615H8.48877C7.11768 14.0615 6.44971 13.4023 6.44971 12.0312V7.43457H3.89209C3.0835 7.43457 2.69678 7.85645 2.69678 8.62109V20.2754ZM8.65576 12.4004H12.6724L8.11963 7.78613V11.8643C8.11963 12.2334 8.28662 12.4004 8.65576 12.4004Z",
    ],
  ],
};

export const customShareIcon: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customShareIcon" as IconName,
  icon: [
    18, // SVG viewBox width
    21, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (calendar)
      "M8.99951 13.4219C8.49854 13.4219 8.09424 13.0176 8.09424 12.543V3.81543L8.17334 2.51465L7.66357 3.17383L6.50342 4.4043C6.354 4.58008 6.12549 4.66797 5.90576 4.66797C5.4751 4.66797 5.11475 4.35156 5.11475 3.90332C5.11475 3.6748 5.20264 3.49902 5.36963 3.34082L8.30518 0.519531C8.53369 0.291016 8.76221 0.203125 8.99951 0.203125C9.23682 0.203125 9.45654 0.291016 9.69385 0.519531L12.6294 3.34082C12.7876 3.49902 12.8755 3.6748 12.8755 3.90332C12.8755 4.35156 12.5151 4.66797 12.0845 4.66797C11.8647 4.66797 11.645 4.58008 11.4868 4.4043L10.3354 3.17383L9.82568 2.51465L9.896 3.81543V12.543C9.896 13.0176 9.50049 13.4219 8.99951 13.4219ZM3.92822 20.5234C1.98584 20.5234 0.94873 19.5039 0.94873 17.5703V9.00977C0.94873 7.08496 1.98584 6.05664 3.92822 6.05664H6.28369V8.0166H4.09521C3.32178 8.0166 2.90869 8.41211 2.90869 9.21191V17.3682C2.90869 18.1768 3.32178 18.5635 4.09521 18.5635H13.9038C14.6685 18.5635 15.0903 18.1768 15.0903 17.3682V9.21191C15.0903 8.41211 14.6685 8.0166 13.9038 8.0166H11.7417V6.05664H14.0708C16.022 6.05664 17.0503 7.08496 17.0503 9.00977V17.5703C17.0503 19.4951 16.022 20.5234 14.0708 20.5234H3.92822Z",
    ],
  ],
};

export const customLightningBolt: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customLightningBolt" as IconName,
  icon: [
    13, // SVG viewBox width
    22, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (calendar)
      "M0 12.1271C0 12.4909 0.276792 12.7616 0.664302 12.7616H5.87722L3.12776 20.3198C2.76792 21.2809 3.75515 21.7941 4.37332 21.0103L12.7601 10.4102C12.9169 10.2142 13 10.0276 13 9.81297C13 9.4584 12.7233 9.17843 12.3357 9.17843H7.12279L9.87229 1.62021C10.2321 0.659099 9.24487 0.145887 8.62667 0.939034L0.239887 11.5299C0.0830379 11.7351 0 11.9218 0 12.1271Z",
    ],
  ],
};

export const customCalendarIcon: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customCalendarIcon" as IconName,
  icon: [
    19, // SVG viewBox width
    19, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (calendar)
      "M15.557 2.70906H14.8042V1.23633H13.2985V2.70906H5.76997V1.23633H4.26426V2.70906H3.51141C2.68327 2.70906 2.00571 3.37178 2.00571 4.18178V15.9636C2.00571 16.7736 2.68327 17.4363 3.51141 17.4363H15.557C16.3852 17.4363 17.0627 16.7736 17.0627 15.9636V4.18178C17.0627 3.37178 16.3852 2.70906 15.557 2.70906ZM15.557 15.9636H3.51141V6.39087H15.557V15.9636Z",
    ],
  ],
};

export const customBoxOutline: IconDefinition = {
  prefix: "fal" as IconPrefix, // 'fal' for FontAwesome Light
  iconName: "customBoxOutline" as IconName,
  icon: [
    30, // SVG viewBox width
    30, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (box outline)
      "M12.75.672C11.466 1.18 1.015 5.511.917 5.576c-.065.042-.179.17-.255.284l-.137.208-.013 8.302-.013 8.302.129.263c.07.144.189.305.263.357.074.052 3.498 1.464 7.609 3.139 6.868 2.797 7.497 3.044 7.75 3.04.254-.004.761-.226 6.498-2.85 6.741-3.083 6.573-2.997 6.696-3.446.08-.289.079-17.042-.001-17.28-.083-.25-.264-.47-.461-.563-.096-.046-1.756-.624-3.691-1.285-3.235-1.107-3.538-1.201-3.791-1.183-.219.016-1.619.558-6.925 2.68-6.58 2.631-6.652 2.662-6.861 2.886-.117.126-.224.296-.24.385-.016.088-.023.726-.014 1.418l.015 1.259.15.212c.2.283.473.42.825.416.306-.005.509-.091.709-.303.219-.231.256-.394.287-1.26l.029-.817 6.05-2.423 6.05-2.424 1.15.389c.633.213 1.583.537 2.113.718l.964.331-4.964 2.17c-5.413 2.367-5.303 2.311-5.432 2.774-.04.143-.056 2.439-.056 7.993 0 7.289-.005 7.791-.084 7.76a4218.61 4218.61 0 0 1-6.425-2.614L2.5 21.833l.012-7.397.013-7.396 5.603-2.31c3.081-1.27 5.684-2.36 5.784-2.422.217-.134.438-.544.438-.812 0-.105-.06-.3-.139-.451a.782.782 0 0 0-.406-.406c-.345-.18-.532-.174-1.055.033m14.738 14.359-.013 7.231-5.018 2.294c-2.76 1.262-5.038 2.294-5.063 2.294-.026 0-.039-3.05-.032-7.327l.013-7.328 5-2.193c2.75-1.206 5.028-2.195 5.063-2.197.05-.004.06 1.455.05 7.226",
    ],
  ],
};

export const customFacility: IconDefinition = {
  prefix: "fad" as IconPrefix, // 'fad' for FontAwesome Duotone
  iconName: "customFacility" as IconName,
  icon: [
    24, // SVG viewBox width
    22, // SVG viewBox height
    [], // Ligatures, not needed
    "", // Unicode, not needed
    // IconPathData tuple
    [
      // secondary path (empty)
      "",
      // Primary path (facility)
      "M22.2252 0.787201H1.74349V3.36426H22.2252V0.787201ZM23.5053 13.6725V11.0954L22.2252 4.65279H1.74349L0.463379 11.0954V13.6725H1.74349V21.4037H14.5446V13.6725H19.665V21.4037H22.2252V13.6725H23.5053ZM11.9843 18.8266H4.3037V13.6725H11.9843V18.8266Z",
    ],
  ],
};
